import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/irin/Projects/Vieillir/vieillir-front/components/layout/landing/Layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/irin/Projects/Vieillir/vieillir-front/components/sections/newsletter/Newsletter1.js");
;
import(/* webpackMode: "eager" */ "/home/irin/Projects/Vieillir/vieillir-front/node_modules/next/dist/client/link.js");
